import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useUpdateEffect } from '@cian/react-utils';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import { generateDataTestId } from '../../../../internal/utils';
import { CalendarPickerHeader } from './CalendarPickerHeader';
import { DayPicker } from './DayPicker';
import { YearPicker } from './YearPicker';
import { ECalendarPickerPage } from './types';
import { useCurrentDate } from './hooks';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD?node-id=49494-10146#1026307539)
 */
export function CalendarPicker(_ref) {
  let {
    selected,
    onChange,
    min,
    max,
    disabledDates,
    dataTestId
  } = _ref;
  const [currentDate, setCurrentDate] = useCurrentDate(selected, min, max);
  const [page, setPage] = React.useState(ECalendarPickerPage.Month);
  const contentRef = React.useRef(null);
  const dayPickerRect = React.useRef({});
  useUpdateEffect(() => {
    setCurrentDate(selected || new Date());
  }, [selected], React.useEffect);
  React.useEffect(() => {
    const contentElement = contentRef.current;
    if (!contentElement) {
      return;
    }
    const rect = contentElement.getBoundingClientRect();
    dayPickerRect.current = {
      width: rect.width,
      height: rect.height
    };
  }, []);
  const handleChangeCurrentYear = nextYear => {
    const nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setFullYear(nextYear);
    setCurrentDate(nextCurrentDate);
    setPage(ECalendarPickerPage.Month);
  };
  const handleChangeYearClick = () => {
    setPage(page => page === ECalendarPickerPage.Year ? ECalendarPickerPage.Month : ECalendarPickerPage.Year);
  };
  const handlePrevMonthClick = () => {
    const nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(nextCurrentDate.getMonth() - 1);
    setCurrentDate(nextCurrentDate);
  };
  const handleNextMonthClick = () => {
    const nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(nextCurrentDate.getMonth() + 1);
    setCurrentDate(nextCurrentDate);
  };
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: () => {},
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['calendar-picker'],
      "data-testid": dataTestId,
      children: [/*#__PURE__*/_jsx(CalendarPickerHeader, {
        current: currentDate,
        min: min,
        max: max,
        page: page,
        onChangeYearClick: handleChangeYearClick,
        onPrevMonthClick: handlePrevMonthClick,
        onNextMonthClick: handleNextMonthClick,
        dataTestId: generateDataTestId(dataTestId, ['header'])
      }), /*#__PURE__*/_jsx("div", {
        ref: contentRef,
        className: styles['content'],
        "data-testid": generateDataTestId(dataTestId, ['content']),
        children: page === ECalendarPickerPage.Month ? /*#__PURE__*/_jsx(DayPicker, {
          selected: selected,
          month: currentDate,
          onChange: onChange,
          min: min,
          max: max,
          disabledDates: disabledDates,
          dataTestId: generateDataTestId(dataTestId, ['days'])
        }) : /*#__PURE__*/_jsx(YearPicker, _objectSpread(_objectSpread({}, dayPickerRect.current), {}, {
          selected: currentDate.getFullYear(),
          onChange: handleChangeCurrentYear,
          min: min && min.getFullYear(),
          max: max && max.getFullYear(),
          dataTestId: generateDataTestId(dataTestId, ['years'])
        }))
      })]
    })
  });
}